module.exports = __webpack_public_path__ + "src/assets/img/start/d1d4d354cdb75a633a052745e59c85d7.png";